import React from "react";
import { Row, Col } from "react-bootstrap";
import myImg from "../../Assets/syep14.png";
import Tilt from "react-parallax-tilt";
import Button from "react-bootstrap/Button";

function Impact2({ onApply }) {
  const videoId = "5mPU-mIQgoQ";

  return (
    <>
      <section className="impact-section" id="internships">
        <Row className="impact-internship-row" style={{ justifyContent: "center" }}>
          <Col md={8} className="impact-internship-left">
            <div className="policy-card impact-copy-card">
              <h2 className="impact-section-heading impact-section-heading-left">
                Internships at <span className="purple">Choicest Fruit</span>
              </h2>

              <p className="home-about-body impact-body">
                At Choicest Fruit<span className="small-r-symbol">®</span>, we believe the future of technology must be ethical,
                inclusive, accessible, affordable, and community-driven. That’s why we created our internship program—giving
                young people real-world experience in Responsible Technology Development while cultivating leadership,
                creativity, and a sense of service.
              </p>

              <h3 className="impact-subheading">A Partnership for Youth Opportunity</h3>
              <p className="home-about-body impact-body">
                For the past two years, Choicest Fruit has partnered with Travis County and the City of Austin through the
                Work-Based Learning / Summer Youth Employment Program. Together, we’ve hosted 7-week internship programs that
                equip high school and college students with valuable career exposure, hands-on training, and meaningful work
                experience in the growing field of ethical tech.
              </p>
              <p className="home-about-body impact-body">
                In addition, Choicest Fruit partners with overseas organizations and companies that serve young people,
                offering their youth the opportunity to intern with us. These global collaborations enrich the program by
                bringing together diverse perspectives and experiences—creating a learning environment where young people
                from different parts of the world can grow, collaborate, and innovate side by side.
              </p>

              <h3 className="impact-subheading">What Interns Experience</h3>
              <p className="home-about-body impact-body">
                Our interns don’t just learn and create technology—they actively solve real community problems using tech and
                help train others to do the same.
              </p>
              <ul className="impact-list">
                <li>
                  <span className="purple">Ethical Tech Design:</span> Applying design thinking and critical reflection to ensure
                  technology serves humanity.
                </li>
                <li>
                  <span className="purple">Hands-On Development:</span> Building EdTech apps and ethical tools using in-demand web
                  technologies.
                </li>
                <li>
                  <span className="purple">Collaborative Projects:</span> Working remotely and on-site with peers to solve real-world
                  problems.
                </li>
                <li>
                  <span className="purple">Career Readiness:</span> Gaining technical skills, teamwork experience, and exposure to
                  pathways in STEM and social impact.
                </li>
              </ul>
              <p className="home-about-body impact-body">
                Interns progress through different stages of their educational journeys while developing their intellectual,
                creative, and moral capacities. They are encouraged to identify the tech needs of their own communities and
                design solutions with a spirit of purpose and service.
              </p>

              <h3 className="impact-subheading">Impact Beyond the Internship</h3>
              <p className="home-about-body impact-body">
                Our internship is more than a summer job—it’s a stepping stone toward leadership and long-term contribution.
                Many participants go on to:
              </p>
              <ul className="impact-list">
                <li>
                  <span className="purple">Mentor peers as Choicest Fruit Ambassadors</span>
                </li>
                <li>
                  <span className="purple">Continue developing community-focused projects</span>
                </li>
                <li>
                  <span className="purple">Apply their skills in higher education and future careers</span>
                </li>
              </ul>
              <p className="home-about-body impact-body">
                By empowering youth to think critically and ethically about technology, we’re cultivating the next generation
                of innovators who will shape a more inclusive and responsible digital world.
              </p>

              <div className="impact-apply-row">
                <Button onClick={onApply} className="custom-yellow-btn impact-apply-btn">
                  Apply Here
                </Button>
              </div>
            </div>
          </Col>

          <Col md={4} className="impact-internship-right">
            <div className="policy-card impact-image-card">
              <Tilt className="impact-tilt" tiltMaxAngleX={6} tiltMaxAngleY={6}>
                <img src={myImg} className="img-fluid impact-image" alt="SYEP interns" />
              </Tilt>
            </div>
          </Col>
        </Row>
      </section>

      <section className="impact-section" aria-label="Summer internship program video">
        <h2 className="impact-section-heading">Summer Internship Program</h2>
        <div className="policy-card impact-video-card">
          <div className="impact-video">
            <iframe
              title="Choicest Fruit internship program overview"
              src={`https://www.youtube.com/embed/${videoId}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </>
  );
}
export default Impact2;
